var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChalkboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -81 512.00103 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb211"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 526.054902 505.570393)",
    gradientUnits: "userSpaceOnUse",
    x1: 73.2448,
    x2: 472.9581,
    xlinkHref: "#a",
    y1: 133.2448,
    y2: 532.9581
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 64.6261736514,
    x2: 455.3932748924,
    xlinkHref: "#a",
    y1: -16.0936293486,
    y2: 374.6734718924
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb211",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2281,
    stopColor: "#ff9f19",
    stopOpacity: 0.227451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6863,
    stopColor: "#ff6f2e",
    stopOpacity: 0.686275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4b3e"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#d",
    y1: 284.8349015252,
    y2: 371.3769936132
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 159.3838614264,
    x2: 431.1269742694,
    y1: 78.6640584264,
    y2: 350.4071712694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575c55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45425a"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45425a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3474,
    stopColor: "#353343",
    stopOpacity: 0.34902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#g",
    y1: 273.6558284864,
    y2: 348.7634497788
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 407.9431023468,
    x2: 399.6483976062,
    xlinkHref: "#d",
    y1: 377.126856476,
    y2: 307.3893143538
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 418.4491460768,
    x2: 392.4578062812,
    xlinkHref: "#g",
    y1: 377.1525568792,
    y2: 324.8905861876
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 387.3538668332,
    x2: 387.3538668332,
    xlinkHref: "#a",
    y1: 316.9016760882,
    y2: 354.9146806572
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 195.905841041,
    x2: 15.2045994744,
    xlinkHref: "#g",
    y1: 259.2231446378,
    y2: 78.521802679
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 262.8391278406,
    x2: 137.1943742448,
    xlinkHref: "#g",
    y1: 276.5055614756,
    y2: 150.8608078798
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 314.2770793546,
    x2: 156.65198888,
    xlinkHref: "#g",
    y1: 269.0384900318,
    y2: 111.4134999494
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 382.0799633906,
    x2: 239.3602032422,
    xlinkHref: "#g",
    y1: 267.9369868134,
    y2: 125.2173270572
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 430.369314336,
    x2: 312.8459885436,
    xlinkHref: "#g",
    y1: 250.0352504938,
    y2: 132.5119247014
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 484.5127352478,
    x2: 343.425653448,
    xlinkHref: "#g",
    y1: 235.9321542378,
    y2: 94.8451728302
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.824219 0h444.351562c18.679688 0 33.824219 15.144531 33.824219 33.828125v282.90625c0 18.679687-15.144531 33.824219-33.824219 33.824219h-444.351562c-18.679688 0-33.824219-15.144532-33.824219-33.824219v-282.90625c0-18.683594 15.144531-33.828125 33.824219-33.828125zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m472.351562 345.96875h-432.703124c-18.195313 0-32.941407-14.75-32.941407-32.941406v-275.496094c0-18.191406 14.746094-32.9375 32.941407-32.9375h432.703124c18.195313 0 32.941407 14.746094 32.941407 32.9375v275.496094c0 18.191406-14.746094 32.941406-32.941407 32.941406zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 258.003906v58.730469c0 18.679687 15.144531 33.824219 33.824219 33.824219h444.351562c18.679688 0 33.824219-15.144532 33.824219-33.824219v-58.730469zm0 0",
    fill: "url(#e)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m466.910156 322.84375h-421.820312c-8.234375 0-14.90625-6.671875-14.90625-14.90625v-265.316406c0-8.230469 6.671875-14.90625 14.90625-14.90625h421.820312c8.234375 0 14.90625 6.675781 14.90625 14.90625v265.316406c0 8.234375-6.671875 14.90625-14.90625 14.90625zm0 0",
    fill: "url(#f)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m481.816406 258.003906h-451.632812v49.933594c0 8.234375 6.671875 14.90625 14.90625 14.90625h421.820312c8.234375 0 14.90625-6.671875 14.90625-14.90625zm0 0",
    fill: "url(#h)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m490.300781 348.308594c-3.765625 1.453125-7.847656 2.246094-12.128906 2.246094h-153.296875l-5.1875-5.1875c-.984375-.648438-1.644531-1.765626-1.644531-3.039063v-19.484375h146.792969zm0 0",
    fill: "url(#i)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m464.835938 322.84375-8.769532-8.769531c-.648437-.988281-1.765625-1.644531-3.035156-1.644531h-131.355469c-2.007812 0-3.632812 1.625-3.632812 3.632812v6.78125zm0 0",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m453.03125 345.96875h-131.355469c-2.007812 0-3.632812-1.628906-3.632812-3.636719v-26.269531c0-2.007812 1.625-3.632812 3.632812-3.632812h131.355469c2.007812 0 3.632812 1.625 3.632812 3.632812v26.269531c0 2.007813-1.625 3.636719-3.632812 3.636719zm0 0",
    fill: "url(#k)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m350.140625 345.960938h-136.65625l-125.75-125.753907c-3.890625-2.859375-6.105469-6.167969-6.105469-9.042969 0-3.261718 2.851563-7.746093 6.25-7.746093 4.894532 0 8.148438 10.730469 23.238282 10.730469 7.324218 0 13.273437-2.582032 15.808593-7.980469-.78125-.769531-33.636719-33.917969-33.636719-33.917969-5.398437-4.25-9.222656-10.207031-9.222656-19.808594 0-20.113281 16.855469-26.09375 31.402344-26.09375 8.203125 0 22.503906 2.003906 24.492188 8.273438l28.171874 28.328125 44.648438 44.894531zm0 0",
    fill: "url(#l)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m378.042969 345.960938h-91.871094l-124.054687-124.050782c-6.515626-4.84375-9.546876-12.613281-9.546876-21.753906v-12.230469c0-11.425781 4.898438-20.941406 15.5625-24.976562 3.542969-1.339844 7.722657-2.078125 12.574219-2.078125 10.855469 0 18.683594 3.992187 20.425781 8.183594l11.648438 11.648437zm0 0",
    fill: "url(#m)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m445.015625 345.960938h-107.585937l-120.152344-120.105469v-.078125c-2.761719-.738282-4.496094-2.617188-4.496094-4.417969v-93.378906c0-2.714844 2.851562-4.617188 7.066406-4.617188 3.800782 0 7.199219 1.902344 7.199219 4.617188v.214843l53.601563 53.558594zm0 0",
    fill: "url(#n)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m495.34375 336.605469c-5.925781 5.789062-14.042969 9.355469-22.996094 9.355469h-56.84375l-125.140625-125.136719c-6.304687-5.074219-10.441406-12.632813-10.441406-20.667969v-12.511719c0-2.011719.246094-3.980469.726563-5.890625 2.898437-11.648437 14.085937-20.882812 27.402343-20.882812 8.910157 0 17.191407 4.304687 22.4375 10.878906zm0 0",
    fill: "url(#o)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m505.292969 280.363281v32.664063c0 15.328125-10.476563 28.207031-24.648438 31.882812l-124.089843-124.085937c-6.304688-5.074219-10.441407-12.632813-10.441407-20.667969v-12.511719c0-2.011719.246094-3.980469.726563-5.890625 2.894531-11.648437 14.085937-20.882812 27.402344-20.882812 8.910156 0 17.191406 4.304687 22.433593 10.878906zm0 0",
    fill: "url(#p)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m505.292969 202.9375v107.554688l-84.691407-84.636719v-.078125c-2.761718-.738282-4.496093-2.617188-4.496093-4.417969v-93.378906c0-2.714844 2.851562-4.617188 7.066406-4.617188 3.945313 0 7.199219 1.902344 7.199219 4.617188v.191406zm0 0",
    fill: "url(#q)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128.242188 199.746094c0-24.058594-44.171876-14.679688-44.171876-47.300782 0-20.113281 16.855469-26.09375 31.398438-26.09375 8.832031 0 24.734375 2.308594 24.734375 9.785157 0 2.71875-1.902344 7.746093-5.980469 7.746093-3.667968 0-7.203125-5.164062-18.753906-5.164062-9.921875 0-16.992188 3.804688-16.992188 12.367188 0 20.117187 44.171876 11.011718 44.171876 47.164062 0 19.4375-13.046876 28.949219-30.988282 28.949219-17.667968 0-30.035156-9.242188-30.035156-16.035157 0-3.261718 2.851562-7.746093 6.25-7.746093 4.894531 0 8.15625 10.734375 23.242188 10.734375 9.785156 0 17.125-4.621094 17.125-14.40625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.570312 200.152344v-12.234375c0-15.222657 8.699219-27.046875 28.136719-27.046875 12.367188 0 20.792969 5.167968 20.792969 9.925781 0 2.71875-2.308594 6.929687-5.707031 6.929687-2.855469 0-5.300781-4.210937-14-4.210937-10.195313 0-14.953125 5.4375-14.953125 14.40625v12.234375c0 8.96875 4.621094 14.40625 15.089844 14.40625 8.96875 0 11.144531-4.488281 14.269531-4.488281 3.804687 0 6.117187 3.941406 6.117187 6.796875 0 4.757812-8.972656 10.328125-21.476562 10.328125-19.570313 0-28.269532-11.550781-28.269532-27.046875zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.050781 221.355469c0 2.3125-3.398437 4.757812-7.203125 4.757812-4.214844 0-7.070312-2.445312-7.070312-4.757812v-93.375c0-2.71875 2.855468-4.621094 7.070312-4.621094 3.804688 0 7.203125 1.902344 7.203125 4.621094v43.222656c2.582031-5.300781 8.699219-10.332031 17.398438-10.332031 12.773437 0 23.648437 12.097656 23.648437 26.777344v33.707031c0 3.125-3.667968 4.757812-7.203125 4.757812-3.261719 0-7.070312-1.632812-7.070312-4.757812v-33.707031c0-7.066407-6.25-14.132813-13.726563-14.132813-6.523437 0-13.046875 5.296875-13.046875 14.132813zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.1875 187.648438v12.507812c0 14.132812-13.183594 27.042969-28.132812 27.042969-15.085938 0-28.136719-12.773438-28.136719-27.042969v-12.507812c0-14.269532 12.640625-26.777344 28.136719-26.777344 14.949218 0 28.132812 12.097656 28.132812 26.777344zm-14.269531 0c0-7.066407-6.253907-14.132813-13.863281-14.132813-7.746094 0-13.863282 7.066406-13.863282 14.132813v12.507812c0 7.335938 6.117188 14.40625 13.863282 14.40625 7.613281 0 13.863281-7.070312 13.863281-14.40625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.378906 187.648438v12.507812c0 14.132812-13.183594 27.042969-28.136718 27.042969-15.085938 0-28.132813-12.773438-28.132813-27.042969v-12.507812c0-14.269532 12.640625-26.777344 28.132813-26.777344 14.953124 0 28.136718 12.097656 28.136718 26.777344zm-14.273437 0c0-7.066407-6.25-14.132813-13.863281-14.132813-7.746094 0-13.863282 7.066406-13.863282 14.132813v12.507812c0 7.335938 6.117188 14.40625 13.863282 14.40625 7.613281 0 13.863281-7.070312 13.863281-14.40625zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.375 127.980469v93.375c0 2.3125-3.261719 4.757812-7.203125 4.757812-4.214844 0-7.066406-2.445312-7.066406-4.757812v-93.375c0-2.71875 2.851562-4.621094 7.066406-4.621094 3.941406 0 7.203125 1.902344 7.203125 4.621094zm0 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChalkboard);
export default __webpack_public_path__ + "static/media/icon-chalkboard.f3ea1aebc564adb64922171733aa22cc.svg";
export { ForwardRef as ReactComponent };